export const en = {
  // Common
  common: {
    loading: 'Loading...',
    error: 'Error',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    search: 'Search',
    filter: 'Filter',
    export: 'Export',
    refresh: 'Refresh',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    confirm: 'Confirm',
    close: 'Close',
    yes: 'Yes',
    no: 'No',
    all: 'All',
    none: 'None',
    noData: 'No data available',
    required: 'Required',
    optional: 'Optional',
    tryAgain: 'Try Again',
  },

  // Auth
  auth: {
    login: 'Login',
    logout: 'Logout',
    signup: 'Sign up',
    forgotPassword: 'Forgot password?',
    resetPassword: 'Reset password',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm password',
    newPassword: 'New password',
    currentPassword: 'Current password',
    rememberMe: 'Remember me',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    signupNow: 'Sign up now',
    loginNow: 'Login now',
    welcomeBack: 'Welcome back',
    createAccount: 'Create your account',
    invalidCredentials: 'Invalid credentials',
    passwordMismatch: 'Passwords do not match',
    passwordReset: 'We sent you a link to reset your password',
    companyName: 'Company name',
    firstName: 'First name',
    lastName: 'Last name',
    confirmAccount: 'Confirm your account',
    verificationCodeSent: 'We sent a verification code to {{email}}',
    yourEmail: 'your email',
    verificationCode: 'Verification code',
    resendCode: 'Resend code',
    waitSeconds: 'Wait {{seconds}} seconds...',
  },

  // Navigation
  nav: {
    dashboard: 'Dashboard',
    analytics: 'Analytics',
    sales: 'Sales',
    products: 'Products',
    customers: 'Customers',
    geography: 'Geography',
    compare: 'Compare',
    settings: 'Settings',
    users: 'Users',
    connectors: 'Connectors',
    jobs: 'Jobs',
    profile: 'Profile',
    billing: 'Billing',
    team: 'Team',
    // E-commerce
    brands: 'Brands',
    categories: 'Categories',
    channels: 'Channels',
    retention: 'Retention',
    rfm: 'RFM Analysis',
    inventory: 'Inventory',
    supplierOrders: 'Supplier Orders',
    smartReorder: 'Smart Reorder',
    orders: 'Orders',
    fulfillment: 'Fulfillment',
    pnl: 'Profit & Loss',
    seasonality: 'Seasonality',
    // SaaS
    mrr: 'MRR',
    churn: 'Churn',
    cac: 'CAC',
    ltv: 'LTV',
    unitEconomics: 'Unit Economics',
    trialConversion: 'Trial Conversion',
    // Restaurant
    service: 'Service',
    menu: 'Menu',
    laborCost: 'Labor Cost',
    recipeProfitability: 'Recipe Profitability',
    menuItems: 'Dishes',
    locationPnl: 'Location P&L',
    // Fashion
    sizePerformance: 'Size Performance',
    colorPerformance: 'Color Performance',
    stores: 'Stores',
    variants: 'Variants',
    collections: 'Collections',
    returns: 'Returns',
    // Logistics
    deliveries: 'Deliveries',
    fleet: 'Fleet',
    driverPerformance: 'Driver Performance',
    customerSatisfaction: 'Customer Satisfaction',
    // Healthcare
    appointments: 'Appointments',
    patients: 'Patients',
    treatments: 'Treatments',
    // Fitness
    memberships: 'Memberships',
    attendance: 'Attendance',
    classes: 'Classes',
    // Hotel
    occupancy: 'Occupancy',
    bookings: 'Bookings',
    revpar: 'RevPAR',
    // Manufacturing
    production: 'Production',
    oee: 'OEE',
    defects: 'Defects',
    // Sales Agent
    customersMap: 'Customers Map',
    territory: 'Territory',
    productMix: 'Product Mix',
    upload: 'Upload Data',
    // Groups
    groups: {
      overview: 'Overview',
      sales: 'Sales',
      catalog: 'Catalog',
      customers: 'Customers',
      operations: 'Operations',
    },
    favorites: 'Favorites',
    pinToFavorites: 'Pin to favorites',
    unpinFromFavorites: 'Remove from favorites',
    maxFavoritesReached: 'Maximum {{max}} favorites',
  },

  // Analytics
  analytics: {
    trend: 'Trend',
    salesTrend: 'Sales Trend',
    by: 'By {{dimension}}',
    // KPI titles
    totalCustomers: 'Total Customers',
    totalRevenue: 'Total Revenue',
    avgRevenuePerCustomer: 'Avg. Revenue/Customer',
    newCustomers: 'New Customers',
    activeBrands: 'Active Brands',
    activeCategories: 'Active Categories',
    activeSkus: 'Active SKUs',
    activeProducts: 'Active Products',
    activationPercent: 'Activation %',
    marginPercent: 'Margin %',
    grossMargin: 'Gross Margin',
    topConcentration: 'Top 10% Conc.',
    top3Concentration: 'Top 3 Conc.',
    negativeMargin: 'Negative Margin',
    catalogCoverage: 'Catalog Coverage',
    // Chart titles
    revenueBySegment: 'Revenue by Segment',
    customersBySegment: 'Customers by Segment',
    revenueConcentration: 'Revenue Concentration',
    abcAnalysis: 'ABC Analysis (Pareto)',
    brandTrend: 'Brand Trend',
    categoryTrend: 'Category Trend',
    productTrend: 'Trend',
    // Dynamic titles with interpolation
    topBrands: 'Top {{count}} Brands',
    topCategories: 'Top {{count}} Categories',
    topProducts: 'Top {{count}} Products',
    topCustomers: 'Top {{count}} Customers',
    // Customer charts
    revenueByCustomer: 'Revenue by Customer',
    quantityByCustomer: 'Quantity by Customer',
    // Retention metrics
    repeatRate: 'Repeat Rate',
    avgClv: 'Avg CLV',
    newVsReturning: 'New vs Returning',
    returningCustomers: 'Returning',
    orderFrequency: 'Order Frequency',
    // Alerts
    belowCostWarning: 'Warning: Below-Cost Sales',
    belowCostMessage: '{{count}} products are being sold below cost. Review pricing to protect margins.',
    // Resource detail
    dailyTrend: 'Daily Trend',
    currentPeriod: 'Current',
    previousPeriod: 'Previous',
    change: 'Change',
    avgPrice: 'Avg Price',
    productCount: 'Products',
    customerCount: 'Customers',
    brandCount: 'Brands',
    noResourceData: 'No data found for this resource',
    searchBrand: 'Search brand...',
    searchCategory: 'Search category...',
    searchProduct: 'Search product...',
    searchGeography: 'Search region...',
    searchSupplier: 'Search supplier...',
    searchCustomer: 'Search customer...',
    sinceLastOrder: 'since last order',
    vatNumber: 'VAT',
    negativeMarginAlert: 'Warning: negative margin ({{percent}}). Review pricing strategy.',
  },

  // Dashboard
  dashboard: {
    title: 'Dashboard',
    overview: 'Overview',
    totalRevenue: 'Total Revenue',
    totalOrders: 'Total Orders',
    grossProfit: 'Gross Profit',
    averageOrderValue: 'Average Order Value',
    newCustomers: 'New Customers',
    returningCustomers: 'Returning Customers',
    itemsSold: 'Items Sold',
    uniqueCustomers: 'Unique Customers',
    vsLastPeriod: 'vs last period',
    revenueByChannel: 'Revenue by Channel',
    ordersByChannel: 'Orders by Channel',
    topProducts: 'Top Products',
    revenueTrend: 'Revenue Trend',
    ordersPerDay: 'Orders per Day',
    noData: 'No data available',
    units: 'units',
    revenue: 'Revenue',
    orders: 'Orders',
    profitMargin: 'Profit Margin',
    conversionRate: 'Conversion Rate',
  },

  // Filters
  filters: {
    dateRange: 'Date Range',
    today: 'Today',
    last7Days: 'Last 7 days',
    last30Days: 'Last 30 days',
    last90Days: 'Last 90 days',
    monthToDate: 'Month to date',
    yearToDate: 'Year to date',
    custom: 'Custom',
    from: 'From',
    to: 'To',
    channels: 'Channels',
    compare: 'Compare',
    compareTo: 'Compare to',
  },

  // Settings
  settings: {
    title: 'Settings',
    general: 'General',
    profile: 'Profile',
    billing: 'Billing',
    team: 'Team',
    connectors: 'Connectors',
    timezone: 'Timezone',
    currency: 'Currency',
    language: 'Language',
    notifications: 'Notifications',
    currentPlan: 'Current plan',
    usage: 'Usage',
    upgrade: 'Upgrade plan',
    inviteUser: 'Invite user',
    role: 'Role',
    roles: {
      owner: 'Owner',
      analyst: 'Analyst',
      viewer: 'Viewer',
    },
  },

  // Users
  users: {
    title: 'Users',
    invite: 'Invite user',
    name: 'Name',
    email: 'Email',
    role: 'Role',
    status: 'Status',
    lastActive: 'Last active',
    actions: 'Actions',
    deleteConfirm: 'Are you sure you want to delete this user?',
    inviteSent: 'Invitation sent successfully',
    statuses: {
      active: 'Active',
      pending: 'Pending',
      disabled: 'Disabled',
    },
  },

  // Connectors
  connectors: {
    title: 'Connectors',
    add: 'Add connector',
    platform: 'Platform',
    status: 'Status',
    lastSync: 'Last sync',
    testConnection: 'Test connection',
    connectionSuccess: 'Connection successful',
    connectionFailed: 'Connection failed',
    apiKey: 'API Key',
    apiSecret: 'API Secret',
    shopUrl: 'Shop URL',
    statuses: {
      active: 'Active',
      error: 'Error',
      syncing: 'Syncing',
      disabled: 'Disabled',
    },
  },

  // Errors
  errors: {
    generic: 'An error occurred. Please try again later.',
    network: 'Connection error. Check your internet connection.',
    unauthorized: 'Session expired. Please login again.',
    forbidden: 'You do not have permission to perform this action.',
    notFound: 'Resource not found.',
    validation: 'Please check the entered data.',
    serverError: 'Server error. Please try again later.',
  },

  // Onboarding
  onboarding: {
    welcome: 'Welcome to Leviathan BI',
    step1Title: 'Choose platform',
    step1Subtitle: 'Select the platform you want to connect',
    step2Title: 'Connect your store',
    step2Subtitle: 'Enter your API credentials',
    step3Title: 'Choose plan',
    step3Subtitle: 'Select the plan that fits your needs',
    orderVolume: 'Monthly order volume',
    platforms: {
      shopify: 'Shopify',
      woocommerce: 'WooCommerce',
      magento: 'Magento',
      prestashop: 'PrestaShop',
      amazon: 'Amazon Seller',
      ebay: 'eBay',
    },
  },

  // Pricing
  pricing: {
    title: 'Plans & Pricing',
    subtitle: 'Choose the perfect plan for your business',
    monthly: 'Monthly',
    yearly: 'Yearly',
    savePercent: 'Save {{percent}}%',
    perMonth: '/month',
    getStarted: 'Get started',
    contactUs: 'Contact us',
    starter: {
      name: 'Starter',
      description: 'For small e-commerce',
    },
    professional: {
      name: 'Professional',
      description: 'For growing businesses',
    },
    business: {
      name: 'Business',
      description: 'For established companies',
    },
    enterprise: {
      name: 'Enterprise',
      description: 'Custom solutions',
    },
  },

  // Tables - common headers
  tables: {
    rank: '#',
    name: 'Name',
    customer: 'Customer',
    brand: 'Brand',
    category: 'Category',
    product: 'Product',
    sku: 'SKU',
    revenue: 'Revenue',
    margin: 'Margin',
    marginPercent: '% Margin',
    orders: 'Orders',
    quantity: 'Quantity',
    products: 'Products',
    share: 'Share',
    lastOrder: 'Last Order',
    class: 'Class',
    locality: 'Locality',
    yoyChange: 'YoY Change',
  },

  // Catalog (generic paginated table)
  catalog: {
    search: 'Search...',
    perPage: 'per page',
    showing: '{{from}}-{{to}} of {{total}}',
    viewAll: 'View all',
    viewAllCount: 'View all ({{count}})',
    noResults: 'No results found.',
    noData: 'No data available.',
    prev: 'Prev',
    next: 'Next',
    title_product: 'Products',
    title_brand: 'Brands',
    title_category: 'Categories',
    title_customer: 'Customers',
    title_inventory: 'Inventory',
    title_geography: 'Geography',
  },

  // Geography
  geography: {
    level: 'Level',
    country: 'Country',
    region: 'Region',
    city: 'City',
    revenueBy: 'Revenue by {{level}}',
    topByRevenue: 'Top 10 {{level}}s by Revenue',
    topLocations: 'Top 10 {{level}}s',
    activeAreas: 'Active Areas',
  },

  // Map (Sales Agent)
  map: {
    subtitle: '{{count}} customers with coordinates',
    year: 'Year',
    compareYear: 'Compare Year',
    brand: 'Brand',
    allBrands: 'All brands',
    colorBy: 'Color by',
    colorByQuantity: 'Quantity',
    colorByRevenue: 'Revenue',
    colorByYoY: 'YoY %',
    totalCustomers: 'Total Customers',
    totalQuantity: 'Total Quantity',
    totalRevenue: 'Total Revenue',
    avgYoY: 'Avg YoY Change',
    customerLocations: 'Customer Locations',
    noCustomersWithCoords: 'No customers with coordinates available',
    topCustomers: 'Top Customers',
    locality: 'Locality',
    province: 'Province',
    address: 'Address',
    quantity: 'Quantity',
    revenue: 'Revenue',
    yoyChange: 'YoY Change',
    segment: 'Segment',
  },

  // Empty states
  empty: {
    noData: 'No data available',
    noDataDescription: 'Configure a data connection to get started.',
    noProducts: 'No products found',
    noProductsDescription: 'Products will appear here after sync.',
    noTeamMembers: 'No team members',
    noTeamMembersDescription: 'Invite collaborators to work together.',
    noConnectors: 'No connectors configured',
    noConnectorsDescription: 'Add your first connector to import data.',
    noResults: 'No results',
    noSearchResults: 'No results found for "{{query}}"',
  },

  // Actions
  actions: {
    configureData: 'Configure Data',
    inviteUser: 'Invite User',
    addConnector: 'Add Connector',
  },

  // Validation messages
  validation: {
    invalidEmail: 'Invalid email',
    passwordRequired: 'Password required',
    companyNameRequired: 'Company name required',
    firstNameRequired: 'First name required',
    lastNameRequired: 'Last name required',
    minChars: 'Minimum {{count}} characters',
    passwordMismatch: 'Passwords do not match',
    codeRequired: '6-digit code required',
    accountConfirmed: 'Account confirmed! Please sign in.',
  },

  // UI elements
  ui: {
    switchToEnglish: 'Switch to English',
    switchToItalian: 'Passa a Italiano',
    darkMode: 'Dark mode',
    lightMode: 'Light mode',
    macro: 'Macro',
    micro: 'Micro',
  },

  // Inventory
  inventory: {
    totalProducts: 'Total Products',
    totalStock: 'Total Stock',
    reservedStock: 'Reserved',
    stockValue: 'Stock Value',
    lowStock: 'Low Stock',
    outOfStock: 'Out of Stock',
    stockTrend: 'Stock Trend',
    byWarehouse: 'By Warehouse',
    topByStockValue: 'Top Products by Stock Value',
    stockLevel: 'Stock',
    reserved: 'Reserved',
    daysOfSupply: 'Days of Supply',
    turnoverRate: 'Turnover Rate',
    reorderPoint: 'Reorder Point',
    warehouse: 'Warehouse',
    allWarehouses: 'All warehouses',
    stockAlert: 'Warning: Stock Issues',
    stockAlertMessage: '{{low}} products below reorder point and {{oos}} out of stock. Review procurement.',
  },

  // Supplier Orders
  supplierOrders: {
    totalSpend: 'Total Spend',
    totalOrders: 'Orders',
    fillRate: 'Fill Rate',
    avgLeadTime: 'Avg Lead Time',
    activeSuppliers: 'Active Suppliers',
    nonConformities: 'Non-Conformities',
    spendTrend: 'Spend & Orders Trend',
    spend: 'Spend',
    orders: 'Orders',
    orderPipeline: 'Order Pipeline',
    fulfillmentBreakdown: 'Line Fulfillment',
    topSuppliers: 'Top Suppliers by Spend',
    supplierTable: 'Supplier Details',
    supplier: 'Supplier',
    city: 'City',
    leadTime: 'Lead Time',
    nonConf: 'Non-Conf.',
    scorecard: 'Supplier Scorecard',
    onTimeRate: 'On-Time %',
    nonConfRate: 'Non-Conf. %',
    fulfillmentRate: 'Fulfillment %',
    score: 'Score',
    grade: 'Grade',
  },

  // Smart Reorder
  smartReorder: {
    title: 'Smart Reorder',
    subtitle: 'Intelligent purchase recommendations based on sales, inventory, and supplier performance',
    preset: 'Strategy',
    conservative: 'Conservative',
    balanced: 'Balanced',
    aggressive: 'Aggressive',
    custom: 'Custom',
    lookbackDays: 'Lookback Days',
    coverageTarget: 'Coverage Target (days)',
    safetyMargin: 'Safety Margin (%)',
    productsToReorder: 'To Reorder',
    criticalCount: 'Critical',
    estimatedValue: 'Estimated Value',
    avgDaysStockout: 'Avg Days to Stockout',
    suppliersInvolved: 'Suppliers Involved',
    totalProducts: 'Products Analyzed',
    priorityBreakdown: 'Priority Breakdown',
    supplierBreakdown: 'Estimated Cost by Supplier',
    recommendations: 'Recommendations',
    product: 'Product',
    sku: 'SKU',
    brand: 'Brand',
    stock: 'Stock',
    demand: 'Demand/day',
    daysLeft: 'Days Left',
    suggestedQty: 'Suggested Qty',
    estCost: 'Est. Cost',
    supplier: 'Supplier',
    leadTime: 'Lead Time',
    priority: 'Priority',
    grade: 'Grade',
    allSuppliers: 'All suppliers',
    exportCsv: 'Export CSV',
    noData: 'Inventory data not available',
    filterByPriority: 'Filter by priority',
    searchProducts: 'Search product, SKU, brand, supplier...',
    viewByProduct: 'By Product',
    viewBySupplier: 'By Supplier',
    trend: 'Trend',
    adjustedForFillRate: 'Quantity adjusted for fill rate',
    products: 'products',
    subtotal: 'Subtotal',
    incoming: 'Incoming',
    allBrands: 'All brands',
    outOfStock: 'Out of stock',
    lowStock: 'Low stock',
    inStock: 'In stock',
    allIncoming: 'All',
    withIncoming: 'Incoming',
    withoutIncoming: 'No incoming',
    allSupplierPresence: 'All',
    withSupplier: 'With supplier',
    withoutSupplier: 'No supplier',
    resetFilters: 'Reset filters',
  },

  // Orders
  orders: {
    totalOrders: 'Total Orders',
    revenue: 'Revenue',
    aov: 'Avg Order Value',
    couponRate: 'Coupon Rate',
    firstOrderRate: 'First Order Rate',
    uniqueCustomers: 'Unique Customers',
    avgItemsPerOrder: 'Items/Order',
    avgDiscount: 'Avg Discount',
    ordersTrend: 'Orders & Revenue Trend',
    orders: 'Orders',
    byPaymentMethod: 'Payment Method',
    byCarrier: 'Carrier',
    byGeography: 'Revenue by Region',
    orderPipeline: 'Order Pipeline',
    hourlyDistribution: 'Hourly Distribution',
    couponAnalysis: 'Coupon Analysis',
    withCoupon: 'With Coupon',
    withoutCoupon: 'Without Coupon',
    firstVsRepeat: 'First vs Repeat',
    firstOrder: 'First Order',
    repeatOrder: 'Repeat Order',
    topCoupons: 'Top Coupons',
    couponCode: 'Coupon Code',
    usageCount: 'Usage Count',
    avgOrderValue: 'Avg Order Value',
    hour: 'Hour',
  },

  // Fulfillment
  fulfillment: {
    avgPickingTime: 'Avg Picking Time',
    avgShippingTime: 'Avg Shipping Time',
    completedRate: 'Completed Rate',
    avgTransitions: 'Avg Transitions',
    avgTimeToComplete: 'Avg Time to Complete',
    stateFunnel: 'State Funnel',
    avgTimePerState: 'Avg Time per State',
    fulfillmentTrend: 'Fulfillment Trend',
    carrierPerformance: 'Carrier Performance',
    slaDistribution: 'Time Distribution',
    carrier: 'Carrier',
    orders: 'Orders',
    avgTime: 'Avg Time',
    pickingTime: 'Picking Time',
    shippingTime: 'Shipping Time',
    byGeography: 'Fulfillment by Region',
  },

  // P&L
  pnl: {
    grossRevenue: 'Gross Revenue',
    discounts: 'Discounts',
    discountRate: 'Discount Rate',
    netRevenue: 'Net Revenue',
    costOfGoods: 'Cost of Goods',
    grossMargin: 'Gross Margin',
    marginPercent: 'Margin %',
    avgOrderValue: 'Avg Order Value',
    revenueTrend: 'Revenue Trend',
    marginTrend: 'Margin & Discount Trend',
    channelBreakdown: 'Channel Breakdown',
    geographyBreakdown: 'P&L by Region',
    categoryBreakdown: 'Top Categories by Margin',
    channel: 'Channel',
  },

  // Seasonality
  seasonality: {
    bestMonth: 'Best Month',
    worstMonth: 'Worst Month',
    bestDay: 'Best Day',
    seasonalityIndex: 'Seasonality Index',
    monthlyHeatmap: 'Monthly Heatmap',
    dayOfWeek: 'Avg Revenue by Day',
    yoyComparison: 'Year-over-Year Comparison',
  },

  // Upload
  upload: {
    pageTitle: 'Upload Data',
    pageDescription: 'Import your data from CSV or Excel files',
    uploading: 'Uploading...',
    confirm: 'Confirm & Import',
    step: {
      select: {
        title: 'Select File',
        description: 'Drag a CSV or Excel file or click to browse',
      },
    },
    dropzone: {
      title: 'Drag file here or click to browse',
      subtitle: 'Supported formats: {{formats}}',
    },
    preview: {
      title: 'Data Preview',
      rowCount: '{{count}} total rows',
    },
    mapping: {
      title: 'Column Mapping',
      description: 'Map file columns to system fields',
      selectColumn: '-- Select column --',
      optional: 'optional',
      missingRequired: 'Missing required fields: {{fields}}',
    },
    entity: {
      customer: 'Customers',
      brand: 'Brands',
      product: 'Products',
      sales: 'Sales',
    },
    smartImport: {
      detected: {
        title: 'Smart Import Detected',
        description: 'We detected a pivot format with years as columns. We can automatically import your data.',
      },
      yearColumns: 'Year Columns',
      yearsDetected: 'years detected',
      transformation: 'Transformation',
      rowsIn: 'rows in',
      factRowsOut: 'sales rows',
      entitiesFound: 'Entities Found',
      entitiesDescription: 'These entities will be automatically created or updated',
      useManualMapping: 'Manual Mapping',
      useSmartImport: 'Use Smart Import',
    },
    processing: {
      title: 'Processing',
      description: 'Importing your data...',
    },
    complete: {
      title: 'Import Complete',
      description: 'Your data has been imported successfully',
      uploadAnother: 'Upload Another File',
      viewMap: 'View Map',
    },
    error: {
      title: 'Import Error',
      generic: 'An error occurred during import',
      invalidFormat: 'Invalid format. Supported formats: {{formats}}',
      fileTooLarge: 'File too large. Max size: {{maxSize}}',
      timeout: 'Processing is taking too long. Try with a smaller file or contact support.',
    },
  },
}
